// Configuration for the QR App
export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_STAGE === 'dev' 
      ? 'https://bpqn5ska6k.execute-api.us-east-1.amazonaws.com/dev'  // Dev stage API
      : 'https://aj56z6o2xd.execute-api.us-east-1.amazonaws.com/prod', // Prod stage API
    
    endpoints: {
      messages: '/messages'
    }
  },
  
  // App Configuration
  app: {
    domain: import.meta.env.VITE_STAGE === 'dev' 
      ? 'dev.youwont.xyz' 
      : 'youwont.xyz',
    
    name: 'QR App',
    description: 'Create and manage dynamic QR codes',
    stage: import.meta.env.VITE_STAGE || 'prod'
  },
  
  // Environment Detection
  isDevelopment: import.meta.env.DEV,
  isDevStage: import.meta.env.VITE_STAGE === 'dev',
  isProdStage: import.meta.env.VITE_STAGE === 'prod' || !import.meta.env.VITE_STAGE,
  
  // Debug information
  debug: {
    viteStage: import.meta.env.VITE_STAGE,
    mode: import.meta.env.MODE,
    nodeEnv: import.meta.env.NODE_ENV,
    buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
    buildNumber: import.meta.env.VITE_BUILD_NUMBER || 'unknown'
  },
  
  // Demo Data (for development)
  demo: {
    message: '👋 Say hi to me IRL! (Demo Mode)',
    handle: 'demo'
  }
}

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${config.api.baseUrl}${endpoint}`
}

// Helper function to build QR code URLs
export const buildQrUrl = (handle: string): string => {
  // For local development, use localhost
  if (import.meta.env.DEV) {
    return `http://localhost:${window.location.port || 3000}/u/${handle}`
  }
  return `https://${config.app.domain}/u/${handle}`
}
